import { useEffect, useState } from "react";
import { auth } from "../firebaseConfig";
import { onAuthStateChanged } from "firebase/auth";
import { useNavigate } from "react-router-dom";

const WORKFLOW_ADMIN_EMAIL = "workflow.admin@shineagri.org"; // same as login page

export default function WorkflowAdminGate({ children }) {
  const [checking, setChecking] = useState(true);
  const [allowed, setAllowed] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (user) => {
      if (!user) {
        setAllowed(false);
        setChecking(false);
        navigate("/workflow/admin-login", { replace: true });
        return;
      }

      const token = await user.getIdTokenResult(true);
      const ok =
        user.email === WORKFLOW_ADMIN_EMAIL ||
        token.claims.workflowAdmin === true;

      if (ok) {
        setAllowed(true);
        setChecking(false);
      } else {
        setAllowed(false);
        setChecking(false);
        navigate("/workflow/admin-login", { replace: true });
      }
    });

    return () => unsub();
  }, [navigate]);

  if (checking) return null; // ya spinner show kar sakte ho
  if (!allowed) return null;

  return children;
}
